import React from 'react';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { ListItemButton } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useUsers } from '../../../hooks/useUsers';
import LoadingSpinner from '../../common/controls/LoadingSpinner';
import UserForm from '../forms/UserForm';
import VerticalHamburgerMenu from '../../common/controls/VerticalHamburgerMenu';
import Box from '@mui/material/Box';
import { useDeleteUser } from '../../../hooks/useDeleteUser';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function Users() {

    const { t } = useTranslation('common');
    
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };   

    const { users, loading, setUsers } = useUsers();

    const { remove } = useDeleteUser(setUsers);

    const [formOpen, setFormOpen] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState(null);
    const [formMode, setFormMode] = React.useState("create");

     const { showSnackbar } = useSnackbar();

    const handleAdd = () => {
        setSelectedUser(null);
        setFormMode("create");
        setFormOpen(true);
    };

    const handleEdit = (user) => {
        setSelectedUser(user);
        setFormMode("edit");
        setFormOpen(true);
    };

    const handleDelete = async (user) => {
        try {
            await remove(user.id);
            showSnackbar(t('users.messages.delete_success', { name: user.name }), "success");
        } catch (err) {
            showSnackbar(t('users.messages.delete_fail', { name: user.name }), "error");
        }
    };

    if (loading) {
        return (
            <LoadingSpinner />
        );
    }

    return(
        <React.Fragment>
            <ListItem>
                <ListItemButton onClick={handleClickOpen} >
                    <ListItemIcon>
                        <PeopleIcon fontSize='large' />
                    </ListItemIcon>

                    <ListItemText 
                        primary="Users"
                        secondary="view, add, edit users"
                    >
                    </ListItemText>
                </ListItemButton>
            </ListItem>

            <Dialog
                onClose={handleClose}
                open={open}
                disableRestoreFocus
            >
                <DialogTitle>
                    Users
                </DialogTitle>
            
                <DialogContent dividers>
                    <List>
                        {users.map((user) => (
                        <ListItem
                            key={user.id}
                            secondaryAction={
                                <Box sx={{ ml: 2, display: 'flex', alignItems: 'right' }}>
                                    <VerticalHamburgerMenu 
                                        options={[
                                        {
                                            id: 1,
                                            name: 'Edit',
                                            callback: () => handleEdit(user),
                                        },
                                        {
                                            id: 2,
                                            name: 'Delete',
                                            callback: () => handleDelete(user),
                                            confirmMessage: t('users.messages.delete_confirm', { name: user.name }),
                                        },
                                        ]}
                                    />
                                </Box>
                            }
                        >
                            <ListItemText 
                                primary={user.name}  
                                secondary={user.email}
                            />
                        </ListItem>
                        ))}
                    </List>

                    <UserForm 
                        setUsers={setUsers} 
                        user={selectedUser}
                        mode={formMode}
                        open={formOpen}
                        onClose={() => setFormOpen(false)}
                    />
                </DialogContent>
                <DialogActions>
                     <Button onClick={handleAdd}>Add User</Button>
                    <div style={{flex: '1 0 0'}} />
                    <Button onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}